import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

import zh from './zh.js'
import en from './en.js'
import { getLanguage } from '../js/data.js'

let locale = getLanguage() || navigator.language.slice(0, 2);
const i18n = new VueI18n({
    locale,
    messages: {
        en: { ...en, ...enLocale },
        zh: { ...zh, ...zhLocale }
    }
})

console.log('i18n:', i18n)

export default i18n

export function t(...params) {
    return i18n.t(...params)
}